import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faCalendarCheck,
  faCalendarTimes,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import { pageNames } from 'config/pageNames';
import { Event } from 'event/types/Event';

import './styles/event-details.css';

interface EventDetailsProps {
  eventData: Event | null;
  showSubDetails?: boolean;
  preText?: string;
}

const EventDetails: React.FC<EventDetailsProps> = ({
  eventData,
  showSubDetails = true,
  preText,
}) => {
  if (!eventData) return <p>No event found</p>;

  return (
    <section className="event-header-card">
      <div className="event-header-left">
        {preText && (
          <p className="event-pretext">
            {preText}
          </p>
        )}

        <Link
          to={`${pageNames.EVENT_READONLY}/${eventData._id}`}
          className="event-title-link"
        >
          <FontAwesomeIcon icon={faChevronLeft} className="me-1" />
          {eventData.title}
        </Link>
      </div>

      {showSubDetails && (
        <div className="event-header-right">
          <p className="event-dates">
            <FontAwesomeIcon icon={faCalendarCheck} className="me-1" />
            {new Date(eventData.startDate).toLocaleDateString()}
            <FontAwesomeIcon icon={faArrowRight} className="mx-2" />
            <FontAwesomeIcon icon={faCalendarTimes} className="me-1" />
            {new Date(eventData.endDate).toLocaleDateString()}
          </p>
        </div>
      )}
    </section>
  );
};

export default EventDetails;
